var net_amount_IR;
var net_amount_IFI;
var net_amount_IS;
let $directDebitBtn = $('#pay_by_direct_debit');
let $numberInput = $('#association_collect_amount');

function toggle_payment() {
  if ($("#association_collect_regular_amount_choice_true:checked").length > 0) {
    $("input#pay_by_cheque").prop("disabled", true).fadeTo("slow", 0.05)
    $("input#pay_by_cash").prop("disabled", true).fadeTo("slow", 0.05)
  } else {
    $("input#pay_by_cheque").prop("disabled", false).fadeTo("slow", 1.0)
    $("input#pay_by_cash").prop("disabled", false).fadeTo("slow", 1.0)
  }

  if ($("#association_collect_regular_amount_choice_true:checked").length > 0 || Number($("input#association_collect_amount").val()) > 2500) {
    $("input#pay_by_cb").prop("disabled", true).fadeTo("slow", 0.05)
  } else {
    $("input#pay_by_cb").prop("disabled", false).fadeTo("slow", 1.0)
  }

  let inputVal = parseFloat($numberInput.val())
  let maxDdValue = Number($directDebitBtn.data('max-dd'))
  let thresholdValue = (maxDdValue + inputVal) / 2
  let availableBalance = Number($directDebitBtn.data('available'))
  if ($("#association_collect_regular_amount_choice_true:checked").length > 0 || thresholdValue > availableBalance) {
    $directDebitBtn.prop("disabled", true).fadeTo("slow", 0.05)
  } else {
    $directDebitBtn.prop("disabled", false).fadeTo("slow", 1.0)
  }
}

let $radioButtons = $('input[type="radio"][name="association_collect[amount_list]"]');

function updateRadioButtons() {
  let numberInputValue = parseFloat($numberInput.val());

  let isMatched = false;

  $radioButtons.each(function() {
    let radioValue = parseFloat($(this).val());

    if (radioValue === numberInputValue) {
      $(this).prop('checked', true);
      isMatched = true;
    } else {
      $(this).prop('checked', false);
    }
  });

  if (!isMatched) {
    $radioButtons.prop('checked', false);
  }
}
$numberInput.on('input', updateRadioButtons);


function update_reduction_feedbacks(amount) {
  net_amount_IR = (Math.round(34 * amount))/100
  net_amount_IFI = (Math.round(25 * amount))/100
  net_amount_IS = (Math.round(40 * amount))/100

  $("input#association_collect_amount").val(amount)
  $(".association_collect_paid_value").text(amount)

  $("span#association_amount_reduction_ir").text(net_amount_IR + " €")
  $("span#association_amount_reduction_ifi").text(net_amount_IFI + " €")
  $("span#association_amount_reduction_is").text(net_amount_IS + " €")
}

function toggle_category_entity_inputs(type){
 if (type == "natural") {
  $(".associations_personal").show();
  $(".associations_business").hide();
  $("input#association_collect_business_entity").prop("required", false);
  $("input#association_collect_business_entity_form").prop("required", false);
  $("input#association_collect_business_entity_registration_number").prop("required", false);
  $("input#association_collect_business_entity").val("");
  $("input#association_collect_business_entity_form").val("");
  $("input#association_collect_business_entity_registration_number").val("");
  $("#form_donation_cost_personal_html").show();
  $("#form_donation_cost_company_html").hide();
 } else {
  $(".associations_personal").hide();
  $(".associations_business").show();
  $("input#association_collect_business_entity").prop("required", true);
  $("input#association_collect_business_entity_form").prop("required", true);
  $("input#association_collect_business_entity_registration_number").prop("required", true);
  $("#form_donation_cost_personal_html").hide();
  $("#form_donation_cost_company_html").show();
 }
}

function set_category_entity(){
  if ($("input#association_collect_category_entity_id_1").is(":checked")) {
    toggle_category_entity_inputs("natural")
  } else if ($("input#association_collect_category_entity_id_2").is(":checked")) {
    toggle_category_entity_inputs("natural")
  } else if ($("input#association_collect_category_entity_id_3").is(":checked")) {
    toggle_category_entity_inputs("legal")
  } else if ($("input#association_collect_category_entity_id_4").is(":checked")) {
    toggle_category_entity_inputs("legal")
  }
}

$(function() {
  $("input#association_collect_regular_amount").fadeTo("fast", 0.5);
  $("#form_donation_cost_personal_html").show();
  $("#form_donation_cost_company_html").hide();
  $("#association_collect_residence_country option[value=\"FR\"]").prop("selected", true);
  $(".associations_personal").show();
  $(".associations_business").hide();

  update_reduction_feedbacks($("input#association_collect_amount").val())
  $("input#association_collect_amount, .amount_list_radio_buttons input").change(function() {
    update_reduction_feedbacks($(this).val())
  });

  toggle_payment()
  $("input#association_collect_amount, input:radio[name=\"association_collect[regular_amount_choice]\"]").change(function() {
    toggle_payment()
  })
  $("input#association_collect_amount").on("input", function() {
    toggle_payment()
  })

  set_category_entity()
  $("input:radio[name=\"association_collect[category_entity_id]\"]").change(function() {
    set_category_entity()
  })
});



// WEBPACK FOOTER //
// ./app/frontend/packs/projects/associations/show.js